<template>
  <section class="employers-tasks-small-banner">
    <div class="content">
      <h4 class="title">Задания от компаний</h4>
      <p class="description">
        Участвуйте в челленджах от компаний, получайте призы и возможность попасть на стажировки
        для студентов
      </p>
    </div>
    <BaseButtonLink
      name="Узнать подробнее"
      link="/students/ambassadors/employers-tasks"
      theme="banana"
    />
  </section>
</template>

<script lang="ts" setup>
  import { BaseButtonLink } from '~/components/base-ui/buttons'

  const img = useImage()
  const employersTasksBannerSmallUrl = `url(${img('/pages/employers-tasks/employers-tasks-banner-small.png', { format: 'webp' })})`
  const employersTasksBannerMobileUrl = `url(${img('/pages/employers-tasks/employers-tasks-banner-mobile.png', { format: 'webp' })})`
</script>

<style lang="scss" scoped>
  .employers-tasks-small-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 19px 40px;
    border-radius: 32px;
    background-image: v-bind(employersTasksBannerSmallUrl),
      linear-gradient(91deg, #b0ecff 0%, #b1ffb1 100%),
      linear-gradient(130deg, #ffeba4 0%, #deedff 100%);
    background-repeat: no-repeat;
    background-position:
      bottom right 180px,
      center,
      center;
    background-size: auto 100%;

    @include vp-1279 {
      padding: 24px 40px;
      background-position:
        bottom right,
        center,
        center;
    }

    @include vp-767 {
      flex-direction: column;
      align-items: flex-start;
      padding: 24px 16px;
      background-image:
        v-bind(employersTasksBannerMobileUrl),
        linear-gradient(91deg, #b0ecff 0%, #b1ffb1 100%),
        linear-gradient(130deg, #ffeba4 0%, #deedff 100%);
      background-size:
        auto 50%,
        cover,
        cover;
    }

    > .content {
      @extend %flex-column;

      gap: 12px;
      max-width: 429px;

      @include vp-767 {
        margin-bottom: 16px;
        max-width: 100%;
      }

      > .title {
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        color: $color-potato-90;

        @include vp-1279 {
          font-size: 20px;
          line-height: 28px;
        }
      }

      > .description {
        font-size: 18px;
        line-height: 26px;
        color: $color-potato-90;

        @include vp-1279 {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    > :deep(.svoi-button) {
      color: $color-potato-90;
      border-radius: 16px;
      background-color: $color-banana-80;
    }
  }
</style>
